"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = void 0;
var Util = /** @class */ (function () {
    // Just some useful methods from matter
    // https://github.com/liabru/matter-js/blob/288b9cdb2f723c74ab151dc3007760f1be086ed9/src/core/Common.js
    function Util() {
    }
    Util.Random = function (min, max) {
        min = (typeof min !== "undefined") ? min : 0;
        max = (typeof max !== "undefined") ? max : 1;
        return min + Util._seededRandom() * (max - min);
    };
    Util._seededRandom = function () {
        // https://en.wikipedia.org/wiki/Linear_congruential_generator
        Util._seed = (Util._seed * 9301 + 49297) % 233280;
        return Util._seed / 233280;
    };
    ;
    Util.Choices = function (arr) {
        return arr[Math.floor(Util.Random(0, 1) * arr.length)];
    };
    Util._seed = 0;
    return Util;
}());
exports.Util = Util;
